import React from 'react';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';

export const UpwardRadio = ({ value, onChange, size, className, name, id, label, checked }) => {
   return (
      <>
         {label
            ? <FormControlLabel value={value} checked={checked} onChange={onChange} className={(className ? className : '') + ' ' + (size === 'small' ? 'MuiFormControlLabel-size-small' : '')} control={<Radio />} label={label} />
            : <Radio name={name} id={id} checked={checked} value={value} onChange={onChange} className={(className ? className : '') + ' ' + (size === 'small' ? 'MuiFormControlLabel-size-small' : '')} />}
      </>
   );
};

export const UpwardReduxRadio = ({ input, ...rest }) => {
   return (
      <UpwardRadio {...input} {...rest} onChange={(event) => input.onChange(event)} />
   );
};
